module.exports = __webpack_public_path__ + "img/logo_outline.e3801aa0.svg";